import { lazy } from "react";

export const ViewWrapper = lazy(() => import("./ViewWrapper"));
export { Tabs } from "./Tabs";
export type { ViewMapType } from "./ViewWrapper";
